import React, { useContext, useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { SwapMainAppContext } from '../../../context/SwapMainAppContext';
import { PRISMAX_BACKEND_URL } from '../../../configs/config';
import {isSessionExpiredError} from '../../../utils/authErrors';

import styles from './OperatorSection.module.css';
import robotSvg from '../../../static_files/robot-unregistration-modal-icon.svg';
import warningIcon from '../../../static_files/triangle-alert-red.svg';

const UnregisterRobotModal = ({ onClose, onRefreshData, robotData }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { userId, gatewayToken, showNotification, handleUserSessionExpired } = useContext(SwapMainAppContext);

    const handleUnregisterRobot = async () => {
        setIsSubmitting(true);
        try {
            const response = await fetch(`${PRISMAX_BACKEND_URL}/api/operator/unregister-robot`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${gatewayToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user_id: userId, machine_id: robotData.machine_id }),
            });
            const result = await response.json();
            if (result.success) {
                await onRefreshData();
                showNotification('success', 'Robot unregistered successfully.');
                onClose();
            } else {
                if (isSessionExpiredError(result.msg)) {
                    handleUserSessionExpired?.();
                    return;
                }
                showNotification('error', result.msg || 'Failed to unregister robot.');
            }
        } catch (err) {
            showNotification('error', 'Failed to unregister robot.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return ReactDOM.createPortal(
        <div className={styles.unregisterModalOverlay} onMouseDown={onClose}>
            <div className={styles.unregisterModalContainer} onMouseDown={(e) => e.stopPropagation()}>
                <h2 className={styles.unregisterModalTitle}>Confirm Unregistration</h2>

                <div className={styles.unregisterModalRobotImageWrapper}>
                    <div className={styles.unregisterModalRobotImageContainer}>
                        <img src={robotSvg} alt="robot" className={styles.unregisterModalRobotSvg} />
                        <div className={styles.unregisterModalXBar1} />
                        <div className={styles.unregisterModalXBar2} />
                    </div>
                </div>

                <p className={`${styles.unregisterModalBodyTextLayout} ${styles.unregisterModalBodyText}`}>
                    Are you sure you want to permanently unregister this robot (Serial: {robotData.serial_number}) from your fleet?
                </p>

                <div className={styles.unregisterModalWarningRow}>
                    <img src={warningIcon} alt="warning" className={styles.unregisterModalWarningIcon} />
                    <span className={styles.unregisterModalBodyText}>This action is irreversible.</span>
                </div>

                <div className={styles.unregisterModalButtonRow}>
                    <button className={styles.unregisterModalCancelButton} onClick={onClose} disabled={isSubmitting}>
                        Cancel
                    </button>
                    <button className={styles.unregisterModalUnregisterButton} onClick={handleUnregisterRobot} disabled={isSubmitting}>
                        {isSubmitting ? 'Unregistering...' : 'Unregister Robot'}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default UnregisterRobotModal;
